import { useState, useEffect, useContext } from 'react'
import AuthContext from 'contexte/AuthContext'
import { fetchLeverageUserPositions, fetchPositionOpenOrders } from 'services/fetchUserById'
import PageLoader from 'components/pageLoader/PageLoader'
import Tableau from 'components/DataComponents/Tableau/Tableau'
import './UserLeveragePositions.css'
import { useTranslation } from 'react-i18next';
import Notification from 'components/notifications/Notification'
import { launchError, launchSuccess } from 'components/notifications'
import TickerImage from 'components/DataComponents/TickerImage/TickerImage'
import { closeUserMarginPosition } from 'services/portfolioServices'
import Modal from 'components/modal/Modal';
import Badge from 'components/Badge/Badge'
import colors from 'assets/colors'
import { formatNumberWithSpaces } from 'utils/numbers'

const UserLeveragePositions = ({ id }) => {

  const { user, verifyUser } = useContext(AuthContext)
  const role = verifyUser()?.role

  const { t } = useTranslation()

  const [loading, setLoading] = useState(true)
  const [portfolio, setPortfolio] = useState([])
  const [page, setPage] = useState(0)
  const [fetchLimit, setFetchLimit] = useState(10)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOrdersOpen, setIsModalOrdersOpen] = useState(false);
  const [closeMarginPositionData, setCloseMarginPositionData] = useState({})
  const [openOrdersData, setOpenOrdersData] = useState([])
  let isModalOpenTemp = false


  const tableHeaders = ['Ticker', 'Side', 'Quantité', 'Argent emprunté', 'Argent investis', 'Coût de base', 'Valeur actuelle', 'Plus value latente']
  if (role === 1) tableHeaders.push('Clôturer')

  const transformeDataToTbody = (data) => {
    return data.length && data.map((item, index) => {
      if (!item) return { data: [] }


      return {
        data: [
          <TickerImage ticker={item.ticker} />,
          <Badge color={colors.badge[item.side]} text={item.side} />,
          formatNumberWithSpaces(item.qty),
          formatNumberWithSpaces(item.borrowed_amount),
          formatNumberWithSpaces(item.invested_liquidity),
          formatNumberWithSpaces(item.cost_basis),
          formatNumberWithSpaces(item.marketValue),
          <div className={`user_leverage_position_cell_${item.unrealizedPl >= 0 ? 'gain' : 'loss'}`}>{formatNumberWithSpaces(item.unrealizedPl)} {item.unrealizedPlpc ? `(${item.unrealizedPlpc}%)` : null}</div>,
          role === 1 && <button className='close_margin_position_button' onClick={(e) => openModal('close_position', index, e)} key={item.id}>Clôturer</button>
        ],
      }
    })
  }
  const openModal = async (type, index, event) => {
    if (type === 'close_position') {
      isModalOpenTemp = true
      setIsModalOpen(true)
      setCloseMarginPositionData(portfolio[index]);
    } else if (type === 'orders' && !isModalOpenTemp) {
      const { ticker, side } = portfolio[index]
      await fetchOpenOrdersData(ticker, side)
      setIsModalOrdersOpen(true)
    }
  }

  const fetchOpenOrdersData = async (ticker, side) => {
    try {
      const data = await fetchPositionOpenOrders(user, id, ticker, side)
      setOpenOrdersData(data)
      setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [page])


  const fetchData = async () => {
    try {
      const data = await fetchLeverageUserPositions(user, id, page, fetchLimit)
      setPortfolio(data)
      setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [page])

  const closeMarginPosition = async (side, ticker) => {
    try {
      setIsModalOpen(false)
      setLoading(true)
      await closeUserMarginPosition(user, { user_uuid: id, side, ticker });
      const updated_data = [...portfolio];
      const index = updated_data.find(item => item.side === side && item.ticker === ticker);
      updated_data.splice(index, 1);
      setPortfolio(updated_data)
      launchSuccess(t('notifications.users.userLeveragePositions.closeMarginPosition.success'))
    } catch (error) {
      console.error(error)
      launchError(t('notifications.users.userLeveragePositions.closeMarginPosition.error'));
    } finally {
      setLoading(false)
    }
  }

  const closeModal = () => {
    isModalOpenTemp = false;
    setIsModalOpen(false)
  }

  return (
    <div>
      {
        !loading ? (
          <div>
            <Notification />
            <Tableau
              tbody={transformeDataToTbody(portfolio)}
              thead={tableHeaders}
              limit={fetchLimit}
              pagination={true}
              setPage={setPage}
              page={page}
              hadModal={true}
              onClickFunction={(index) => openModal('orders', index)}
            />
            <ModalOpenOrders
              isModalOpen={isModalOrdersOpen}
              onClose={() => setIsModalOrdersOpen(false)}
              orders={openOrdersData}
              closeMarginPosition={closeMarginPosition}
            />
            <ModalCloseMarginPosition
              isModalOpen={isModalOpen}
              onClose={closeModal}
              closeMarginPositionData={closeMarginPositionData}
              closeMarginPosition={closeMarginPosition}
            />
          </div>
        ) : (
          <div className='pageLoaderBox'>
            <PageLoader />
          </div>
        )
      }
    </div>
  )
}


const ModalCloseMarginPosition = ({ isModalOpen, onClose, closeMarginPositionData, closeMarginPosition }) => {

  const { t } = useTranslation()

  const { ticker, qty, marketValue, side } = closeMarginPositionData;


  return (
    <Modal isOpen={isModalOpen} onClose={onClose} closeButton >
      <h2 className='modal-playlist_title'>Clôturer la position</h2>
      <div className="payout-details">


        <div className='warning_deleted'>
          <img src="https://assets-global.website-files.com/612cdb668b06dbb2a51f99ee/651e6e6668d310d564622c79_warning_img.png" alt="" width={25} />
          <span>Êtes-vous sûr de vouloir {side === 'SHORT' ? 'acheter' : 'vendre'} <strong>{qty}</strong> action(s) <strong>{ticker} </strong>
            pour un montant <strong>≈ {marketValue} €</strong> ?
          </span>
        </div>
      </div>
      <hr className='modal_hr_button' />
      <div className='close_position_modal_button_div'>
        <button className='close' onClick={onClose}>{t("pages.payouts.buttons.close")}</button>
        <button className='validate' onClick={() => { closeMarginPosition(side, ticker) }}>{side === 'LONG' ? 'Vendre' : 'Acheter'}</button>
      </div>
    </Modal>

  )
}

const ModalOpenOrders = ({ isModalOpen, onClose, orders }) => {

  const { t } = useTranslation()

  return (
    <Modal isOpen={isModalOpen} onClose={onClose} closeButton >

      {orders.length > 0 ?
        (<>
          <h2 className='modal-playlist_title'>Ordres ouverts sur la position : </h2>
          <div className="payout-details">

            {orders.map(({ client_order_id, amount, order_type, order_limit }) => (
              <div key={client_order_id} className='open_orders_div'>
                <p>Quantité : <span>{amount}</span></p>
                <p>Type d'ordre : <span>{order_type}</span></p>
                <p>Valeur : <span>{order_limit}</span></p>
                <hr className='modal_hr_button' />
              </div>
            )
            )}
          </div>
        </>) :
        <h2 className='modal-playlist_title'>Aucun ordre ouvert sur cette position </h2>
      }
      <div className='close_position_modal_button_div'>
        <button className='close' onClick={onClose}>{t("pages.payouts.buttons.close")}</button>
      </div>
    </Modal>

  )
}

export default UserLeveragePositions